import { useMemo, useRef, useState } from "react";
import { ColDef, ColumnState } from "ag-grid-community";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import { aggridHeaderClass, pdaCellStyle } from "src/components/common/common";
import { GridContextWrapper } from "src/components/common/gridWrapper/GridContextWrapper";
import Grid_Select from "src/components/common/gridWrapper/Grid_Select";
import { PDA1123_R01RecoverItem } from "./PDA1123_R01Dto";
import usePDA1123_R01Store from "./usePDA1123_R01Store";

type Row = PDA1123_R01RecoverItem & { inserted?: boolean };

const PDA1123_R01Table = () => {
  const { recoverList, removeRecover } = usePDA1123_R01Store();
  const gridRef = useRef<AgGridReact<Row>>(null);
  const gridWrapperRef = useRef<HTMLDivElement>(null);
  const [, setHoveredRowIndex] = useState<number | null>(null);
  const [, setColumnState] = useState<ColumnState[] | null>(null);
  const paddedGridData = useMemo(
    () => recoverList.map((item) => ({ ...item, inserted: false })),
    [recoverList]
  );

  const columnDefs: ColDef<Row>[] = useMemo(
    () => [
      {
        headerName: "품명",
        field: "itemNm",
        valueGetter: (params) => params.data?.itemNm ?? "-",
        cellStyle: { textAlign: "left", ...pdaCellStyle },
        headerClass: aggridHeaderClass,
        flex: 1.4,
        minWidth: 80,
      },
      {
        headerName: "위치",
        field: "warehouseCd",
        valueGetter: (params) => params.data?.warehouseCd || "-",
        cellStyle: { textAlign: "center", ...pdaCellStyle },
        headerClass: aggridHeaderClass,
        flex: 0.7,
        minWidth: 70,
      },
      {
        headerName: "수량",
        field: "lotQty",
        valueGetter: (params) =>
          params.data?.lotQty != null ? params.data.lotQty.toLocaleString() : "-",
        cellStyle: { textAlign: "right", justifyContent: "flex-end", ...pdaCellStyle },
        headerClass: aggridHeaderClass,
        flex: 0.8,
        minWidth: 70,
      },
      {
        headerName: "Lot",
        field: "lotNo",
        valueGetter: (params) => params.data?.lotNo ?? "-",
        cellStyle: { textAlign: "left", ...pdaCellStyle },
        headerClass: aggridHeaderClass,
        flex: 1.2,
        minWidth: 80,
      },
    ],
    []
  );

  const handleRowClick = (lotNo?: string) => {
    if (!lotNo) return;
    if (window.confirm(`LOT ${lotNo} 을(를) 회수 목록에서 제거할까요?`)) {
      removeRecover(lotNo);
    }
  };

  return (
    <div className="flex-1 p-3 pt-2 flex w-full h-full flex-col overflow-hidden">
      <GridContextWrapper
        gridRef={gridRef}
        gridWrapperRef={gridWrapperRef}
        paddedGridData={paddedGridData}
        initSelected={() => {}}
        baseColumnDefs={columnDefs}
        setColumnState={setColumnState}
        localStorageKey="PDA1123_R01_RecoverTable_ColumnState"
        enableDataHistory={false}
      >
        <div className="flex-1 w-full h-full min-h-0">
          <Grid_Select<Row>
            ref={gridRef}
            rowData={paddedGridData}
            columnDefs={columnDefs}
            onRowClicked={(event) => handleRowClick(event.data?.lotNo)}
            setHoveredRowIndex={setHoveredRowIndex}
            columnStateKey="PDA1123_R01_RecoverTable_ColumnState"
            setColumnState={setColumnState}
          />
        </div>
      </GridContextWrapper>
      {recoverList.length > 0 && (
        <div className="px-2 py-2 border-t border-gray-200 bg-white">
          <p className="text-sm text-gray-500 text-center">
            행을 누르면 회수 목록에서 제거됩니다 · 등록 시 삭제됩니다
          </p>
        </div>
      )}
    </div>
  );
};

export default PDA1123_R01Table;
